// import React, { useState, useEffect, useRef } from "react";
// import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Divider } from "@mui/material";
// import { CheckCircle } from "@mui/icons-material";
// import { motion } from "framer-motion";
// import api from "../services/httpService"; 


// const Services = () => {
//   const [adminServices, setAdminServices] = useState([]);
//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const [animate, setAnimate] = useState(false);
//   const servicesRef = useRef(null);

//   useEffect(() => {
//     const element = servicesRef.current;
//     const observer = new IntersectionObserver(
//       ([entry]) => setAnimate(entry.isIntersecting),
//       { threshold: 0.1 }
//     );
//     if (element) observer.observe(element);
//     return () => { if (element) observer.unobserve(element); };
//   }, []);

//   // Fetch admin services
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const res = await api.get("/sentinix/services");
//         if (res.data.success) {
//           const filtered = res.data.data.filter(s => s.type === "service" && !s.isDeleted);
//           setAdminServices(filtered);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchServices();
//   }, []);

//   return (
//     <Box
//       ref={servicesRef}
//       sx={{ height: "auto", minHeight: "80vh", paddingTop: "0rem", paddingBottom: "0rem", display: "flex", alignItems: "center", justifyContent: "center" }}
//     >
//       <Box sx={{ width: "100%", maxWidth: "1200px" }}>
//         <motion.div initial={{ opacity: 0, y: 50 }} animate={animate ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} transition={{ duration: 0.8 }}>
//           <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center", marginBottom: "2rem" }}>
//             <Typography variant="h3" fontWeight="bold" color="#005fa3" gutterBottom>
//               Our Services
//             </Typography>
//             <Typography variant="subtitle1" color="#555" fontSize={"1.2rem"} fontStyle={"italic"}>
//               "Explore our wide range of services tailored to meet your business needs."
//             </Typography>
//           </Box>
//         </motion.div>

//         <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, height: "auto", padding: "2rem 2rem" }}>
//           <motion.div initial={{ opacity: 0, x: -50 }} animate={animate ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} transition={{ duration: 0.8, delay: 0.2 }}>
//             <Box sx={{ minWidth: 280, backgroundColor: "#005fa3", borderRadius: 2, color: "#fff", marginBottom: { xs: "2rem", md: "0" } }}>
//               <List>
//                 {adminServices.map((service, index) => (
//                   <ListItem disablePadding key={service.id}>
//                     <ListItemButton
//                       selected={selectedIndex === index}
//                       onClick={() => setSelectedIndex(index)}
//                       sx={{
//                         "&.Mui-selected": { backgroundColor: "#ffffff", color: "black", fontWeight: "bold" },
//                         "&:hover": { backgroundColor: "#ffffffaa", color: "black" },
//                       }}
//                     >
//                       <ListItemText primary={service.name} primaryTypographyProps={{ sx: { fontSize: "1rem", fontWeight: "bold", padding: "1px 0px" } }} />
//                     </ListItemButton>
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           </motion.div>

//           <motion.div initial={{ opacity: 0, x: 50 }} animate={animate ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }} transition={{ duration: 0.8, delay: 0.4 }}>
//             <Box sx={{ flex: 1, paddingLeft: { xs: "0", md: "4rem" } }}>
//               {adminServices[selectedIndex] && (
//                 <>
//                   <Typography variant="h5" fontWeight="bold" gutterBottom>
//                     {adminServices[selectedIndex].name}
//                   </Typography>
//                   <Typography variant="body1" mb={2}>
//                     {adminServices[selectedIndex].description}
//                   </Typography>
//                   <Divider />
//                   <Box sx={{ marginTop: 2 }}>
//                     {/* {[adminServices[selectedIndex].name]?.map((point, i) => (
//                       // <Box key={i} sx={{ display: "flex", alignItems: "start", mb: 1 }}>
//                       //   <CheckCircle sx={{ color: "#1976d2", mr: 1, mt: "4px" }} />
//                       //   <Typography>{point}</Typography>
//                       // </Box>
//                     ))} */}
//                   </Box>
//                 </>
//               )}
//             </Box>
//           </motion.div>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Services;

import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Divider } from "@mui/material";
import { motion } from "framer-motion";
import api from "../services/httpService"; 

const Services = () => {
  const [adminServices, setAdminServices] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  // const [themeColors, setThemeColors] = useState({
  //   color1: "#f83600",
  //   color2: "#fe8c00"
  // });
  const servicesRef = useRef(null);

  useEffect(() => {
    const element = servicesRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => setAnimate(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (element) observer.observe(element);
    return () => { if (element) observer.unobserve(element); };
  }, []);

  // Fetch admin services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await api.get("/sentinix/services");
        if (res.data.success) {
          const filtered = res.data.data.filter(s => s.type === "service" && !s.isDeleted);
          setAdminServices(filtered);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchServices();
  }, []);

  // Fetch theme colors
  useEffect(() => {
    const fetchThemeColors = async () => {
      try {
        const res = await api.get("/sentinix/dashboardsettings");
        if (res.data.success && res.data.data) {
          const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
          const latest = allData.sort((a, b) => b.id - a.id)[0];

          if (latest) {
            const color1 = latest.color1 || "";
            const color2 = latest.color2 || "";
            
            //setThemeColors({ color1, color2 });
            
            // Apply to CSS variables
            document.documentElement.style.setProperty("--theme-color1", color1);
            document.documentElement.style.setProperty("--theme-color2", color2);
          }
        }
      } catch (err) {
        console.error("Error fetching theme colors:", err);
      }
    };
    fetchThemeColors();
  }, []);

  return (
    <Box
      ref={servicesRef}
      sx={{ height: "auto", minHeight: "80vh", paddingTop: "0rem", paddingBottom: "0rem", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box sx={{ width: "100%", maxWidth: "1200px" }}>
        <motion.div initial={{ opacity: 0, y: 50 }} animate={animate ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} transition={{ duration: 0.8 }}>
          <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center", marginBottom: "2rem" }}>
            <Typography 
              variant="h3" 
              fontWeight="bold" 
              sx={{
                background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                mb: 1,
              }}
              gutterBottom
            >
              Our Services
            </Typography>
            <Typography variant="subtitle1" color="#555" fontSize={"1.2rem"} fontStyle={"italic"}>
              "Explore our wide range of services tailored to meet your business needs."
            </Typography>
          </Box>
        </motion.div>

        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, height: "auto", padding: "2rem 2rem" }}>
          <motion.div initial={{ opacity: 0, x: -50 }} animate={animate ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }} transition={{ duration: 0.8, delay: 0.2 }}>
            <Box sx={{ 
              minWidth: 280, 
              background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
              borderRadius: 2, 
              color: "#fff", 
              marginBottom: { xs: "2rem", md: "0" },
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}>
              <List>
                {adminServices.map((service, index) => (
                  <ListItem disablePadding key={service.id}>
                    <ListItemButton
                      selected={selectedIndex === index}
                      onClick={() => setSelectedIndex(index)}
                      sx={{
                        "&.Mui-selected": { 
                          backgroundColor: "#ffffff", 
                          color: "black", 
                          fontWeight: "bold",
                          borderLeft: `4px solid var(--theme-color1)`,
                        },
                        "&:hover": { 
                          backgroundColor: "rgba(255,255,255,0.2)", 
                          color: "white" 
                        },
                      }}
                    >
                      <ListItemText 
                        primary={service.name} 
                        primaryTypographyProps={{ 
                          sx: { 
                            fontSize: "1rem", 
                            fontWeight: "bold", 
                            padding: "1px 0px" 
                          } 
                        }} 
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Box>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 50 }} animate={animate ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }} transition={{ duration: 0.8, delay: 0.4 }}>
            <Box sx={{ flex: 1, paddingLeft: { xs: "0", md: "4rem" } }}>
              {adminServices[selectedIndex] && (
                <>
                  <Typography 
                    variant="h5" 
                    fontWeight="bold" 
                    gutterBottom
                    sx={{
                      background: "linear-gradient(135deg, var(--theme-color1), var(--theme-color2))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    {adminServices[selectedIndex].name}
                  </Typography>
                  <Typography variant="body1" mb={2} sx={{ color: "#444" }}>
                    {adminServices[selectedIndex].description}
                  </Typography>
                  <Divider sx={{ 
                    background: "linear-gradient(90deg, var(--theme-color1), var(--theme-color2))",
                    height: "2px",
                    opacity: 0.3,
                  }} />
                  <Box sx={{ marginTop: 2 }}>
                  </Box>
                </>
              )}
            </Box>
          </motion.div>
        </Box>
      </Box>
    </Box>
  );
};

export default Services;